<input
  type="text"
  class="form-control audit-info-input"
  readonly
  tabindex="-1"
  [value]="dateLocal ? (dateLocal | date : 'yyyy-MM-dd h:mm:ss a') : '--'"
  [class.audit-info-empty]="!dateLocal"
/>
